import clsx from 'clsx'
import {omit} from 'lodash'
import React, {useContext} from 'react'
import {useHistory} from 'react-router-dom'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import {makeStyles} from 'external/material'

import {faUser} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import {TeacherContext} from 'teacher/context'

const useSelectStyles = makeStyles(selectStyles)
const useStyles = makeStyles(studentStyles)

export default function SelectStudent (props) {

  const {group: {students = []}} = props

  const history = useHistory()
  const context = useContext(TeacherContext)
  const selectClasses = useSelectStyles()
  const classes = useStyles() 

  const {link, linkQuery, groupMembers, groupId, studentId} = context

  const handleStudentChange = event => history.push(linkQuery(link({groupId, studentId: event.target.value}), {}))

  const value = students.length == 0 || studentId == undefined ? '' : studentId

  return (
    <div className={classes.container}>
      <span className={clsx(classes.icon, classes.middle)}><FontAwesomeIcon icon={faUser}/></span>
      <span className={clsx(classes.select, classes.middle)}>
        <Select
          classes={selectClasses}
          onChange={handleStudentChange}
          value={value}
          IconComponent={ArrowDropDownIcon}
        >
          {students.map(student => (<MenuItem value={student.id} key={student.id}>{student.name}</MenuItem>))}
        </Select>
      </span>
    </div>
  )
}

function studentStyles() {
  return {
    container: {
      display: 'flex',
    },
    middle: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    select: {
      '& .MuiInput-underline:before': {
        content: 'none',
        border: 'none'
      },
      '& .MuiInput-underline:after': {
        content: 'none',
        border: 'none'
      }
    },
    icon: {
      marginRight: 8,
      color: '#3295ce',
      marginTop: -2
    },
  }
}

function selectStyles() {
  return {
    root: {
      color: '#4f576e',
      fontSize: '11pt',
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },
    icon: {
      color: '#4f576e',
      fontWeight: 'bold'
    }
  }
}
